import React, { useEffect, useState } from 'react';
import api from '../api';
import './PageTable.css';

const SECTIONS = [
  { label: 'Hero', fields: [
    { key: 'hero_eyebrow', label: 'Eyebrow (teks kecil di atas judul)' },
    { key: 'hero_title', label: 'Judul utama' },
    { key: 'hero_desc', label: 'Deskripsi', textarea: true },
  ]},
  { label: 'Section Artis', fields: [
    { key: 'artists_eyebrow', label: 'Eyebrow' },
    { key: 'artists_title', label: 'Judul section' },
  ]},
  { label: 'Section Video', fields: [
    { key: 'video_eyebrow', label: 'Eyebrow' },
    { key: 'video_title', label: 'Judul section' },
  ]},
  { label: 'Section Berita', fields: [
    { key: 'news_eyebrow', label: 'Eyebrow' },
    { key: 'news_title', label: 'Judul section' },
  ]},
  { label: 'Section Event', fields: [
    { key: 'events_eyebrow', label: 'Eyebrow' },
    { key: 'events_title', label: 'Judul section' },
  ]},
  { label: 'Section Store', fields: [
    { key: 'store_eyebrow', label: 'Eyebrow' },
    { key: 'store_title', label: 'Judul section' },
  ]},
];

function SiteContent() {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [dirty, setDirty] = useState(false);

  const fetchContent = async () => {
    setLoading(true);
    try {
      const res = await api.get('/site-content/admin/all');
      const map = {};
      res.data.forEach((row) => {
        map[row.key] = row.value;
      });
      setContent(map);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  const handleChange = (key, value) => {
    setContent({ ...content, [key]: value });
    setDirty(true);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put('/site-content', { updates: content });
      setDirty(false);
      alert('Konten berhasil disimpan');
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menyimpan konten');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p>Memuat...</p>;

  return (
    <div>
      <div className="page-header-row">
        <h1 className="page-title" style={{ marginBottom: 0 }}>Pengaturan Situs</h1>
        <button className="btn-primary" onClick={handleSave} disabled={!dirty || saving}>
          {saving ? 'Menyimpan...' : 'Simpan Semua Perubahan'}
        </button>
      </div>
      <p style={{ color: '#888', marginBottom: 24 }}>
        Ubah teks yang tampil di landing page tanpa perlu akses database. Perubahan langsung terlihat di saskararecord.com setelah disimpan.
      </p>

      {SECTIONS.map((section) => (
        <div key={section.label} className="content-section-card" style={{ marginBottom: 24, padding: 20, border: '1px solid #333', borderRadius: 8 }}>
          <h3 style={{ marginTop: 0, marginBottom: 16 }}>{section.label}</h3>
          {section.fields.map((field) => (
            <div key={field.key} style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 13, color: '#aaa', marginBottom: 6 }}>
                {field.label}
              </label>
              {field.textarea ? (
                <textarea
                  rows={3}
                  value={content[field.key] || ''}
                  onChange={(e) => handleChange(field.key, e.target.value)}
                  style={{ width: '100%' }}
                />
              ) : (
                <input
                  type="text"
                  value={content[field.key] || ''}
                  onChange={(e) => handleChange(field.key, e.target.value)}
                  style={{ width: '100%' }}
                />
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default SiteContent;
